export default [{
    value: 'Coverholder_Name',
    text: 'Coverholder Name',
    sortable: true,
    width: 170,
    default: true,
    disabled: true
  },
  {
    value: 'TPA_Name',
    text: 'TPA Name',
    sortable: true,
    width: 170,
    default: true,
    disabled: true
  },
  {
    value: 'Agreement',
    text: 'Agreement No',
    default: true
  },
  {
    value: 'Unique_Market_Reference_UMR',
    text: 'Unique Market Reference (UMR)',
    sortable: true,
    width: 120,
    default: true,
    disabled: true
  },
  {
    value: 'Binder_Contract_Inception',
    text: 'Binding Authority Or Coverholder Appointment Agreement Inception Date',
    default: true,
    isDate: true
  },
  {
    value: 'Binder_Contract_Expiry',
    text: 'Binding Authority Or Coverholder Appointment Agreement Expiry Date',
    default: true,
    isDate: true
  },
  {
    value: 'Reporting_Period_End_Date',
    text: 'Reporting Period (End Date)',
    sortable: true,
    width: 200,
    default: true,
    isDate: true
  },
  {
    value: 'Class_of_Business',
    text: 'Class of Business',
    default: true
  },
  {
    value: 'Risk_Code',
    text: "Lloyd's Risk Code",
    default: true,
    disabled: true
  },
  {
    value: 'Section_No',
    text: 'Section No',
    default: true,
    disabled: true
  },
  {
    value: 'Original_Currency',
    text: 'Original Currency',
    default: true
  },
  {
    value: 'Settlement_Currency',
    text: 'Settlement Currency',
    default: true,
    disabled: true
  },
  {
    value: 'Rate_of_Exchange',
    text: 'Rate Of Exchange',
    default: true,
    decimals: 2
  },
  {
    value: 'Certificate_Reference',
    text: 'Certificate Reference',
    default: true
  },
  {
    value: 'Claim_Reference',
    text: 'Claim Reference / Number',
    default: true,
    disabled: true
  },
  {
    value: 'Insured_Full_Name',
    text: 'Insured Full Name Or Company Name',
    default: true
  },
  {
    value: 'Insured_State',
    text: 'Insured State, Province, Territory, Canton etc.',
    default: true
  },
  {
    value: 'Insured_Country',
    text: 'Insured Country',
    default: true
  },
  {
    value: 'Location_of_Risk_State',
    text: 'Location Of Risk State, Province, Territory, Canton',
    default: true
  },
  {
    value: 'Location_of_Risk_County',
    text: 'Location of Risk County',
    default: true
  },
  {
    value: 'Risk_Inception_Date',
    text: 'Risk Inception Date',
    default: true,
    isDate: true
  },
  {
    value: 'Risk_Expiry_Date',
    text: 'Risk Expiry Date',
    default: true,
    isDate: true
  },
  {
    value: 'Period_of_Cover',
    text: 'Period of Cover - Narrative',
    default: true
  },
  {
    value: 'Loss_State',
    text: 'Location Of Loss State, Province, Territory, Canton',
    default: true
  },
  {
    value: 'Location_of_Loss_Country',
    text: 'Location of Loss Country',
    default: true
  },
  {
    value: 'Cause_of_Loss',
    text: 'Cause of Loss Code',
    default: true
  },
  {
    value: 'Loss_Description',
    text: 'Loss Description',
    default: true
  },
  {
    value: 'Date_of_Loss_From',
    text: 'Date of Loss (From)',
    default: true,
    isDate: true
  },
  {
    value: 'Date_of_Loss_To',
    text: 'Date of Loss (To)',
    default: true
  },
  {
    value: 'Date_Claim_Made',
    text: 'Date Claim First Advised/Date Claim Made',
    default: true,
    isDate: true
  },
  {
    value: 'Claim_Status',
    text: 'Claim Status',
    default: true
  },
  {
    value: 'Refer_to_Underwriters',
    text: 'Refer to Underwriters',
    default: true
  },
  {
    value: 'Denial',
    text: 'Denial',
    default: true
  },
  {
    value: 'Litigation_status',
    text: 'Litigation Status',
    default: true
  },
  {
    value: 'Claimant_Name',
    text: 'Claimant Name',
    default: true
  },
  {
    value: 'Loss_County',
    text: 'Loss County',
    default: true
  },
  {
    value: 'State_of_Filing',
    text: 'State of Filing',
    default: true
  },
  {
    value: 'PCS_Code',
    text: 'PCS Code',
    default: true
  },
  {
    value: 'Medicare_United_States_Bodily_Injury',
    text: 'Medicare United States Bodily Injury',
    default: true
  },
  {
    value: 'Medicare_Eligibility_Check_Performed',
    text: 'Medicare Eligibility Check Performance',
    default: true
  },
  {
    value: 'Medicare_Outcome_of_Eligibility_Status_Check',
    text: 'Medicare Outcome of Eligibility Status Check',
    default: true
  },
  {
    value: 'Medicare_Conditional_Payments',
    text: 'Medicare Conditional Payments',
    default: true
  },
  {
    value: 'Medicare_MSP_Compliance_Services',
    text: 'Medicare MSP Compliance Services',
    default: true
  },
  {
    value: 'Paid_This_Month_Indemnity',
    text: 'Paid This Month - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_This_Month_Indemnity_Buildings',
    text: 'Paid this month - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Paid_This_Month_Indemnity_Contents',
    text: 'Paid this month - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Paid_This_Month_Fees',
    text: 'Paid This Month - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Indemnity',
    text: 'Previously Paid - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Indemnity_Buildings',
    text: 'Previously Paid - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Previously_Paid_Indemnity_Contents',
    text: 'Previously Paid - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Previously_Paid_Fees',
    text: 'Previously Paid - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Indemnity',
    text: 'Reserve - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Indemnity_Buildings',
    text: 'Reserve - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Reserve_Indemnity_Contents',
    text: 'Reserve - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Reserve_Fees',
    text: 'Reserve - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Change_This_Month_Indemnity',
    text: 'Change This Month - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Change_This_Month_Fees',
    text: 'Change This Month - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Incurred_Indemnity',
    text: 'Total Incurred - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Incurred_Indemnity_Buildings',
    text: 'Total Incurred - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Total_Incurred_Indemnity_Contents',
    text: 'Total Incurred - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Total_Incurred_Fees',
    text: 'Total Incurred - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Coverholder_PIN',
    text: 'Coverholder PIN',
    default: true
  },
  {
    value: 'Reporting_Period_Start_Date',
    text: 'Reporting Period Start Date',
    default: true
  },
  {
    value: 'Type_of_Insurance',
    text: 'Type of Insurance (Direct, or Type of RI)',
    default: true
  },
  {
    value: 'Policy_or_Group_Ref',
    text: 'Policy or Group Ref',
    default: true
  },
  {
    value: 'Insured_Address',
    text: 'Insured Address',
    default: true
  },
  {
    value: 'Insured_Postcode_Zip_Code_or_similar',
    text: 'Insured Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Location_of_Risk_Location_ID',
    text: 'Location Of Risk Location ID',
    default: true
  },
  {
    value: 'Location_of_Risk_Address',
    text: 'Location Of Risk Address',
    default: true
  },
  {
    value: 'Location_of_Risk_Postcode_Zip_Code_or_similar',
    text: 'Location Of Risk Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Deductible_Amount',
    text: 'Deductible Amount',
    default: true,
    decimals: 2
  },
  {
    value: 'Deductible_Basis',
    text: 'Deductible Basis',
    default: true
  },
  {
    value: 'Sums_Insured_Amount',
    text: 'Sums Insured Amount',
    default: true,
    decimals: 2
  },
  {
    value: 'Location_of_Loss_Address',
    text: 'Location of Loss Address',
    default: true
  },
  {
    value: 'Location_of_Loss_Postcode_Zip_Code_or_similar',
    text: 'Location Of Loss Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Date_Closed',
    text: 'Date Closed',
    default: true,
    isDate: true
  },
  {
    value: 'Lloyds_Cat_Code',
    text: "Lloyd's Cat Code",
    default: true,
    disabled: true
  },
  {
    value: 'Catastrophe_Name',
    text: 'Catastrophe Name',
    default: true
  },
  {
    value: 'Paid_this_month_Expenses',
    text: 'Paid This Month - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Attorney_Coverage_Fees',
    text: 'Paid This Month - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Adjusters_Fees',
    text: 'Paid This Month - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Defence_Fees',
    text: 'Paid This Month - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_TPA_Fees',
    text: 'Paid This Month - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Bank_Charges',
    text: 'Paid This Month - Bank Charges',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Expenses',
    text: 'Previously Paid - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Attorney_Coverage_Fees',
    text: 'Previously Paid - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Adjusters_Fees',
    text: 'Previously Paid - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Defence_Fees',
    text: 'Previously Paid - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_TPA_Fees',
    text: 'Previously Paid - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Bank_Charges',
    text: 'Previously Paid - Bank Charges',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Expenses',
    text: 'Reserve - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Attorney_Coverage_Fees',
    text: 'Reserve - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Adjusters_Fees',
    text: 'Reserve - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Defence_Fees',
    text: 'Reserve - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_TPA_Fees',
    text: 'Reserve - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reclosed_Date',
    text: 'Reclosed Date',
    default: true,
    isDate: true
  },
  {
    value: 'Net_Recovery',
    text: 'Net Recovery',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Incurred',
    text: 'Total Incurred',
    default: true,
    decimals: 2
  },
  {
    value: 'Reg_No_of_Vehicle_etc',
    text: 'Name Or Reg No Of Aircraft Vehicle, Vessel Etc.',
    default: true
  },
  {
    value: 'Ceded_Reinsurance',
    text: '% Ceded (Reinsurance)',
    default: true
  },
  {
    value: 'Plan',
    text: 'Plan',
    default: true
  },
  {
    value: 'Patient_Name',
    text: 'Patient Name',
    default: true
  },
  {
    value: 'Treatment_Type',
    text: 'Treatment Type',
    default: true
  },
  {
    value: 'Country_of_Treatment',
    text: 'Country Of Treatment',
    default: true
  },
  {
    value: 'Date_of_Treatment',
    text: 'Date Of Treatment',
    default: true
  },
  {
    value: 'Expert_Role',
    text: 'Expert Role',
    default: true
  },
  {
    value: 'Expert_Firm',
    text: 'Expert Firm / Company Name',
    default: true
  },
  {
    value: 'Expert_Reference_No',
    text: 'Expert Reference No Etc.',
    default: true
  },
  {
    value: 'Expert_Address',
    text: 'Expert Address',
    default: true
  },
  {
    value: 'Expert_State',
    text: 'Expert State, Province, Territory, Canton Etc.',
    default: true
  },
  {
    value: 'Expert_Postcode_Zip_Code_or_similar',
    text: 'Expert Postcode / Zip Code Or Similar',
    default: true
  },
  {
    value: 'Expert_Country',
    text: 'Expert Country',
    default: true
  },
  {
    value: 'Notes',
    text: 'Notes',
    default: true
  },
  {
    value: 'Date_Claim_Opened',
    text: 'Date Claim Opened',
    default: true,
    isDate: true
  },
  {
    value: 'Ex_gratia_payment',
    text: 'Ex Gratia Payment',
    default: true,
    decimals: 2
  },
  {
    value: 'Claim_First_Notification_Acknowledgement_Date',
    text: 'Claim First Notification Acknowledgement Date',
    default: true,
    isDate: true
  },
  {
    value: 'Date_First_Reserve_Established',
    text: 'Date First Reserve Established',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Coverage_Confirmed',
    text: 'Date Coverage Confirmed',
    default: true,
    isDate: true
  },
  {
    value: 'Diary_date',
    text: 'Diary date',
    default: true,
    isDate: true
  },
  {
    value: 'Peer_review_date',
    text: 'Peer Review Date',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Claim_Amount_Agreed',
    text: 'Date Claim Amount Agreed',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Claims_Paid',
    text: 'Date Claims Paid',
    default: true,
    isDate: true
  },
  {
    value: 'Date_of_Subrogation',
    text: 'Date of Subrogation',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Reopened',
    text: 'Date Reopened',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Claim_Denied',
    text: 'Date Claim Denied',
    default: true,
    isDate: true
  },
  {
    value: 'Reason_for_Denial',
    text: 'Reason For Denial',
    default: true
  },
  {
    value: 'Date_claim_withdrawn',
    text: 'Date Claim Withdrawn',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Coverage_Confirmed',
    text: 'Date Coverage Confirmed',
    default: true,
    isDate: true
  },
  {
    value: 'Subrogation_Recovered_This_Month',
    text: 'Subrogation Recovered This Month',
    default: true,
    decimals: 2
  },
  {
    value: 'Subrogation_Previously_Recovered',
    text: 'Subrogation Previously Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Subrogation_Recovered',
    text: 'Total Subrogation Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Salvage_Recovered_This_Month',
    text: 'Salvage Recovered This Month',
    default: true,
    decimals: 2
  },
  {
    value: 'Salvage_Previously_Recovered',
    text: 'Salvage Previously Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Salvage_Recovered',
    text: 'Total Salvage Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Deductible_Recovered_This_Month',
    text: 'Deductible Recovered This Month',
    default: true,
    decimals: 2
  },
  {
    value: 'Deductible_Previously_Recovered',
    text: 'Deductible Previously Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Deductible_Recovered',
    text: 'Total Deductible Recovered',
    default: true,
    decimals: 2
  },
  {
    value: 'Gross_Recovery_Received_This_Month',
    text: 'Gross Recovery Received This Month',
    default: true,
    decimals: 2
  },
  {
    value: 'Gross_Recovery_Previously_Received',
    text: 'Gross Recovery Previously Received',
    default: true,
    decimals: 2
  },
  {
    value: 'Gross_Recovery_Total',
    text: 'Gross Recovery Total',
    default: true,
    decimals: 2
  },
  {
    value: 'Recovery_Fees_Paid_This_Month',
    text: 'Recovery Fees Paid This Month',
    default: true,
    decimals: 2
  },
  {
    value: 'Recovery_Fees_Paid_Previously_Paid',
    text: 'Recovery Fees Paid Previously Paid',
    default: true,
    decimals: 2
  },
  {
    value: 'Recovery_Fees_Total',
    text: 'Recovery Fees Total',
    default: true,
    decimals: 2
  },
  {
    value: 'Driver_Age',
    text: 'Driver Age',
    default: true
  },
  {
    value: 'Cargo_Hauled',
    text: 'Cargo Hauled',
    default: true
  },
  {
    value: 'Reefer_Claim',
    text: 'Reefer Claim',
    default: true
  },
  {
    value: 'Reefer_Age',
    text: 'Reefer Age',
    default: true
  },
  {
    value: 'Cargo_Total_Insured_Value',
    text: 'Cargo Total Insured Value',
    default: true
  },
  {
    value: 'Vehicle_Unit_Age',
    text: 'Vehicle Unit Age',
    default: true
  },
  {
    value: 'Vehicles_Total_Insured_Value',
    text: 'Vehicles Total Insured Value',
    default: true,
    decimals: 2
  },
  {
    value: 'Towing_Storage_Fees',
    text: 'Towing Storage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Trailer_Interchange',
    text: 'Trailer Interchange',
    default: true
  },
  {
    value: 'Non_Owned_Trailer',
    text: 'Non Owned Trailer',
    default: true
  },
  {
    value: 'MTC_Peril',
    text: 'MTC Peril',
    default: true
  },
  {
    value: 'Fault',
    text: 'Fault',
    default: true
  },
  {
    value: 'Distance',
    text: 'Distance',
    default: true,
    decimals: 2
  },
  {
    value: 'Year_of_Account',
    text: 'Year of Account',
    default: true,
    disabled: true
  },
  {
    value: 'BDX_Key',
    text: 'LimeIQ BDX Key',
    width: 170,
    default: true,
    disabled: true,
    hidden: true
  }
]